import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomePage.vue'),
    children: [
      { // 填写信息
        path: '/fillInfo',
        name: 'fillInfo',
        component: () => import('../components/quotedPage/fillInfo.vue')
      },
      { // 报价单
        path: '/quotedList',
        name: 'quotedList',
        component: () => import('../components/quotedPage/quotedList.vue')
      },
      { // 报价展示
        path: '/priceList',
        name: 'priceList',
        component: () => import('../components/quotedPage/priceList.vue')
      },
      { // 新闻列表
        path: '/newsIndex',
        name: 'newsIndex',
        component: () => import('../components/newsPage/newsIndex.vue')
      },
      { // 新闻详情
        path: '/newsdetail',
        name: 'newsdetail',
        component: () => import('../components/newsPage/newsdetail.vue')
      }
    ]
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
